/** ⭐ ONE WAKE PER OPENED FIXTURE.
 *
 * Two watchers name the open fixture — the store poll (`watchOpenEvent`, 500 ms)
 * and the network hint (`onOpenMatchObserved`, two looks) — and both called the
 * wake, so each one scheduled its own pin poll; the ladder landing added a third
 * ask. The refresh throttle folds asks inside MIN_REFRESH_MS into a TRAILING
 * call, so every open became two identical /suggestions posts ~2.4 s apart
 * (parikara 2026-10-19, fetch hook: caller wakeOnOpen's timer, then the
 * throttle's trailing timer).
 *
 * - the same fixture woken again inside `dedupeMs` is the same open: no-op;
 * - a ladder that lands BEFORE the pin poll fires rides on that poll (it reads
 *   the catalog when it is built) instead of asking for another. */
export interface OpenWakeDeps {
  /** Fetch the fixture's ladder; resolves when it is in hand. */
  prime: (id: string) => Promise<void>;
  /** The ladder landed after the pin poll went out: post it. */
  onLadder: (id: string) => void;
  /** The pin poll. */
  poll: () => void;
  after: (fn: () => void, ms: number) => void;
  now: () => number;
}

export function makeOpenWaker(deps: OpenWakeDeps, pinDelayMs: number,
                              dedupeMs: () => number): (id: string) => void {
  let lastId = "";
  let lastAt = -Infinity;
  return (id: string): void => {
    const t = deps.now();
    if (id === lastId && t - lastAt < dedupeMs()) return;
    lastId = id;
    lastAt = t;
    let pinSent = false;
    void deps.prime(id).then(() => { if (pinSent) deps.onLadder(id); }, () => {});
    deps.after(() => { pinSent = true; deps.poll(); }, pinDelayMs);
  };
}
